import { render } from "./VabChartSunburst.vue?vue&type=template&id=c0861694"
import script from "./VabChartSunburst.vue?vue&type=script&lang=js"
export * from "./VabChartSunburst.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/echarts/components/VabChartSunburst.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0861694"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0861694', __exports__)) {
    console.log('reload')
    api.reload('c0861694', __exports__)
  }
  
  module.hot.accept("./VabChartSunburst.vue?vue&type=template&id=c0861694", () => {
    console.log('re-render')
    api.rerender('c0861694', render)
  })

}


export default __exports__